/**
* @ngdoc directive
* @name Bind Element
*
* @description
  Adds $element to object provided as 'element' property
*
* @scope
* @param {Object} bindElement - object that will get element
*/

app.directive('bindElement', function() {
  return {
    restrict: 'A',
    scope: {
      bindElement: '='
    },
    link: function($scope, $element) {
      if ($scope.bindElement) {
        $scope.bindElement.element = $element[0];
      }
    }
  };
});



// WEBPACK FOOTER //
// ./~/ng-annotate-loader/loader.js!./project/components/bindElement.js